module.exports = __webpack_public_path__ + "img/sidebar_user_active.9351d411.svg";